<template>
  <tr
    class="salesrow"
    :class="{ selectedRow: item.isSelect }"
    @click="selectRow()"
    @focusout="calcProfit()"
  >
    <td style="text-align: center" class="GYONO meisaiCont cwU_1">
      <input
        type="text"
        readonly="true"
        v-model="item.c_sales_rownum"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      />
    </td>
    <td
      style="text-align: center; position: relative"
      class="CLAIMNO meisaiCont cwU_2"
    >
      <i
        class="fal fa-external-link claimLnk"
        @click.stop="linkClaim($event)"
        v-if="item.isApprovedClaim == 1"
      ></i>
      <select
        :class="{
          selectWithClimlink:
            item.isApprovedClaim == 1 &&
            $store.state.authType == authtypeNyuryokusya,
        }"
        v-model="item.cnvClaimnumTmp"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      >
        <option
          v-for="option in claims"
          v-bind:value="option.c_claim_number"
          v-bind:key="option.c_claim_number!"
          :disabled="
            item.isApprovedClaim == 1 &&
            $store.state.authType == authtypeNyuryokusya
          "
          style="text-align: right"
        >
          {{ option.c_claim_number }}
        </option>
      </select>
    </td>
    <td class="CLAIM_DATE meisaiCont cwU_3 disableGray">
      <!-- <input
        type="date"
        class="datepicker hasDatepicker"
        v-model="item.cnvDateIssue"
      /> -->

      <Mt_dtp
        v-model:contdate="item.cnvDateIssue"
        v-model:holidays="mastersData"
        class="dtpJyutyuBulk jyutyuTable"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      ></Mt_dtp>
    </td>
    <td class="SALESMONTH meisaiCont cwU_4 disableGray">
      <!-- <input
        type="month"
        class="datepickerYearMonth hasDatepicker"
        v-model="item.cnvDateMonth"
      /> -->
      <Mt_dtp4month
        v-model:contdate="item.cnvDateMonth"
        class="dtpJyutyuBulk noneBorder"
        v-bind:minDate="getMinDate()"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      ></Mt_dtp4month>
    </td>
    <td
      style="text-align: left"
      class="ITEMIZE meisaiCont cwU_5 selectBorderNone"
    >
      <select
        v-model="item.c_sales_item"
        @change="cngItem()"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      >
        <option
          v-for="option in opItemtypeItem"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td style="text-align: left" class="COURSE meisaiCont cwU_6">
      <select
        v-model="item.c_sales_subject"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      >
        <option
          v-for="option in getOpItemtypeSubjects()"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td style="text-align: left" class="BREAK_DOWN cwU_7">
      <select
        v-model="item.c_sales_breakdown"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      >
        <option
          v-for="option in getOpItemtypeBreakdown()"
          v-bind:value="option.code"
          v-bind:key="option.code"
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td
      style="text-align: left"
      class="SALES_CD meisaiCont cwU_8 selectBorderNone disableGray"
    >
      <vSelect
        :options="opClients"
        v-model="item.c_client_id"
        label="c_client_name"
        :reduce="(label:any) => label.c_client_id"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      ></vSelect>
    </td>
    <td
      class="SUM meisaiCont cwU_9"
      id="Sales_SUM_1"
      style="position: relative"
    >
      <VTooltip v-if="item.isMissMatch" class="isMissMatchIcon">
        <i class="fal fa-info-circle"></i>
        <template #popper>
          請求No{{
            item.c_sales_climnum_tmp
          }}は、申請中または、承認済みですが、売上明細の合計値と、請求書の合計値が一致していません<br />
          請求No{{ item.c_sales_climnum_tmp }}の税抜き合計金額は、{{
            item.subTotal4Claim!.toLocaleString("ja-JP")
          }}円です
        </template>
      </VTooltip>
      <input
        type="text"
        :class="{ isMissMatch: item.isMissMatch }"
        maxlength="10"
        v-model="item.cnvPrice"
        @focus="kanmaDel($event)"
        @blur="kanmaIns($event)"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      />
    </td>
    <td
      style="text-align: left"
      class="SYOHIZEI_RITU meisaiCont cwU_10 selectBorderNone"
    >
      <select
        v-model="item.c_sales_taxrate"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      >
        <option
          v-for="option in opTaxtate"
          v-bind:value="option.code"
          v-bind:key="option.code"
          :disabled="
            item.isApprovedClaim == 1 &&
            $store.state.authType == authtypeNyuryokusya
          "
        >
          {{ option.label }}
        </option>
      </select>
    </td>
    <td class="NYUKIN_YOTEI_DATE meisaiCont cwU_11 disableGray">
      <Mt_dtp
        v-model:contdate="item.cnvDateExpPayment"
        v-model:holidays="mastersData"
        class="dtpJyutyuBulk jyutyuTable"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      ></Mt_dtp>
    </td>
    <td
      class="NYUKIN_DATE meisaiCont cwU_12"
      :class="{
        tdDisables:
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya,
      }"
    >
      <!-- <Mt_dtp
        v-model:contdate="item.cnvDateCmpPayment"
        class="dtpJyutyuBulk jyutyuTable"
      ></Mt_dtp> -->
      <span style="padding-left: 10px">
        {{ item.cnvDateCmpPayment.date?.replaceAll("-", "/") }}
      </span>
    </td>
    <td class="BIKO meisaiCont cwU_13">
      <input
        type="text"
        v-model="item.c_sales_remarks"
        :disabled="
          item.isApprovedClaim == 1 &&
          $store.state.authType == authtypeNyuryokusya
        "
      />
    </td>
  </tr>
</template>
<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import {
  CONST_OP_TERM_ITEM,
  CONST_OP_TAXRATE,
  CONST_OP_ITEMTYPE_ITEM,
  CONST_OP_ITEMTYPE_SUBJECTS,
  CONST_OP_ITEMTYPE_BREAKDOWNS,
  CONST_ITEMTYPE_ITEM_KEIYAKU,
  CONST_ITEMTYPE_ITEM_KEIZOKU,
  CONST_ITEMTYPE_ITEM_KURIKOSI,
  CONST_ITEMTYPE_ITEM_MAEUKE,
  CONST_ITEMTYPE_ITEM_NESAGE,
  CONST_ITEMTYPE_ITEM_SHINKI,
  CONST_ITEMTYPE_ITEM_SYOUDAKU,
  CONST_ITEMTYPE_ITEM_TEKKYO,
  CONST_ITEMTYPE_SUBJECTS_BAITAI,
  CONST_ITEMTYPE_SUBJECTS_HIKAZEI,
  CONST_ITEMTYPE_SUBJECTS_KOUJI,
  CONST_AUTHORITY_STAFF_NYURYOKUSYA,
} from "furukawa-common/src/common/constant/Constants";
import { EntitySalesImple } from "furukawa-common/src/common/entity/EntitySalesImple";

import Mt_dtp from "@/components/atoms/Mt_dtp.vue";
import Mt_dtp4month from "@/components/atoms/Mt_dtp4month.vue";
import { DtoMdDtp } from "furukawa-common/src/common/dto/DtoMdDtp";
import "@vuepic/vue-datepicker/dist/main.css";
import { EntityClient } from "furukawa-common/src/common/entity/EntityClient";
import { DtoMastersGetRes } from "furukawa-common/src/common/dto/DtoMastersGetRes";
import { EntityClaim } from "furukawa-common/src/common/entity/EntityClaim";
import { item } from "@/dto/DtoItemsGetRes";
import "floating-vue/dist/style.css";
import { Cl_common } from "@/functions/Cl_common";

@Options({
  components: {
    vSelect,
    Mt_dtp,
    Mt_dtp4month,
  },
})
export default class Mo_tableJyutu_row_sales extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntitySalesImple;

  @Prop({ required: true })
  mastersData: DtoMastersGetRes;

  @Prop({ required: true })
  claims: EntityClaim[];

  authtypeNyuryokusya = CONST_AUTHORITY_STAFF_NYURYOKUSYA;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  opItemtypeItem = CONST_OP_ITEMTYPE_ITEM;
  // opItemtypeSubjects = CONST_OP_ITEMTYPE_SUBJECTS;
  // opItemtypeBreakdown = CONST_OP_ITEMTYPE_BREAKDOWNS;
  opTermItem = CONST_OP_TERM_ITEM;
  opTaxtate = CONST_OP_TAXRATE;
  opClients: EntityClient[] = [];

  //----------------------
  //セレクトボックス用メソッド
  //----------------------
  cngItem() {
    this.item.c_sales_subject = null;
    this.item.c_sales_breakdown = null;
  }
  getOpItemtypeSubjects(): {
    label: string;
    code: number;
  }[] {
    let indices: number[] = [];

    switch (this.item.c_sales_item) {
      case CONST_ITEMTYPE_ITEM_SHINKI:
        return CONST_OP_ITEMTYPE_SUBJECTS;
      case CONST_ITEMTYPE_ITEM_KEIZOKU:
        return CONST_OP_ITEMTYPE_SUBJECTS;
      case CONST_ITEMTYPE_ITEM_KEIYAKU:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_SYOUDAKU:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_NESAGE:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_KURIKOSI:
        indices.push(0); // 媒体
        indices.push(1); // 工事
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_TEKKYO:
        indices.push(0); // 媒体のみ
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      case CONST_ITEMTYPE_ITEM_MAEUKE:
        indices.push(0); // 媒体
        indices.push(1); // 工事
        return indices.map((i) => CONST_OP_ITEMTYPE_SUBJECTS[i]);
      default:
        return [{ label: "項目を選択してください", code: -1 }];
    }
  }
  getOpItemtypeBreakdown(): {
    label: string;
    code: number;
  }[] {
    let indices: number[] = [];
    switch (this.item.c_sales_subject) {
      case CONST_ITEMTYPE_SUBJECTS_BAITAI:
        indices.push(0); // 長期媒体
        indices.push(1); // 短期媒体
        indices.push(2); // 保守媒体
        indices.push(3); // 放映料
        return indices.map((i) => CONST_OP_ITEMTYPE_BREAKDOWNS[i]);
      case CONST_ITEMTYPE_SUBJECTS_KOUJI:
        indices.push(4); // 施工費
        indices.push(5); // 撤去費
        indices.push(6); // 貼替料
        indices.push(7); // 電気代
        indices.push(8); // 保守管理費
        indices.push(9); // その他
        return indices.map((i) => CONST_OP_ITEMTYPE_BREAKDOWNS[i]);
      case CONST_ITEMTYPE_SUBJECTS_HIKAZEI:
        indices.push(10); // 申請代
        indices.push(11); // 保険代
        return indices.map((i) => CONST_OP_ITEMTYPE_BREAKDOWNS[i]);
      default:
        return [{ label: "科目を選択してください", code: -1 }];
    }
  }

  //----------------------
  //モーダル用プロパティ
  //----------------------

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    this.opClients = this.mastersData.getClient4NoneDelete([
      this.item.c_client_id!,
    ]);
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 日付の最小値を取得
   */
  getMinDate(): Date | undefined {
    //制限は入力者のみ
    //-------
    if (this.$store.state.authType != CONST_AUTHORITY_STAFF_NYURYOKUSYA) {
      return undefined;
    }
    //前々月以前は選択不可
    //-------
    let dt = new Date();
    dt.setMonth(dt.getMonth() - 1);
    return dt;
  }
  /**
   * クリック時の選択処理
   */
  async selectRow() {
    if (
      this.item.isApprovedClaim == 1 &&
      this.$store.state.authType == this.authtypeNyuryokusya
    ) {
      return;
    }

    this.item.isSelect = true;
    this.$emit("selected", this.item.c_sales_id);
  }

  /**
   * 選択解除処理
   */
  async noneSelectRow() {
    this.item.isSelect = false;
  }

  //------------------

  /**
   * 金額セル入力時の処理
   * カンマを消す
   * @param obj
   */
  kanmaDel(obj: any) {
    // カンマを消す
    this.item.cnvPrice = obj.target.value.replace(/,/g, "");
    // if (this.item.cnvPrice == "0") this.item.cnvPrice = "";
  }
  /**
   * 金額セル入力時の処理
   * カンマを付ける
   * @param obj
   */
  kanmaIns(obj: any) {
    let val: string = obj.target.value;

    //うっかり入力しているかもしれないカンマを消す
    val = val.replace(/,/g, "");
    //整数に変換したのち文字列に戻す
    //この時点で数字とマイナス記号だけが残る
    let num = "" + parseInt(val);
    //正規表現で桁区切りするための良く見かける関数的な何か
    //変数 num の中身が、桁区切りされる
    while (num != (num = num.replace(/^(-?\d+)(\d{3})/, "$1,$2")));
    //numに入っている値が数値じゃないときは空白とする
    if (isNaN(parseInt(num))) num = "";
    //桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
    this.item.cnvPrice = num;
  }

  /**
   * 金額再計算イベント発生
   */
  calcProfit() {
    //再計算イベント発生
    //-----------------------
    this.$emit("reCalc");
  }

  async linkClaim(event?: MouseEvent) {
    if (this.item.c_sales_climnum_tmp == null) {
      return;
    }
    Cl_common.goTo(
      "/invoiceCreationForm?claimnum=" + this.item.c_sales_climnum_tmp,
      this.$router,
      event
    );
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
tr {
  border-bottom: 1px solid #ccc;
}

td,
td {
  /* border: solid 1px #5e5e5e; */
  padding: 0;
  margin: 0;
  border-right: 1px solid #ccc;
  height: 28px;
}
tr > td:last-child {
  border-right: none;
}
td > input,
td > input,
td > select,
td > select {
  width: 100%;
  height: 28px;
  border: none;
}
/* .cwU_1 {
  min-width: 20px;
  max-width: 45px;
} */
.cwU_1 input {
  text-align: right;
}
/* .cwU_2 {
  min-width: 70px;
  max-width: 70px;
} */
.cwU_2 input {
  text-align: right;
}
/* .cwU_3 {
  min-width: 100px;
  max-width: 100px;
} */
.cwU_3 input {
  text-align: right;
}
/* .cwU_4 {
  min-width: 100px;
  max-width: 100px;
} */
.cwU_4 input {
  text-align: right;
}
.cwU_6-2 input {
  text-align: right;
}
/* .cwU_5 {
  min-width: 60px;
  max-width: 60px;
} */
/* .cwU_6 {
  min-width: 215px;
  max-width: 215px;
} */
/* .cwU_7 {
  min-width: 100px;
  max-width: 100px;
} */
.cwU_7 input {
  text-align: right;
}
/* .cwU_8 {
  min-width: 100px;
  max-width: 100px;
} */
.cwU_8 input {
  text-align: right;
}
.cwU_9 input {
  text-align: right;
}
/* .cwU_9 {
  min-width: 90px;
  max-width: 90px;
} */
/* .cwU_10 {
  min-width: 55px;
  max-width: 55px;
} */
/* .cwU_11 {
  min-width: 100px;
  max-width: 100px;
} */
.cwU_11 input {
  text-align: right;
}
/* .cwU_12 {
  min-width: 100px;
  max-width: 100px;
} */
.cwU_12 input {
  text-align: right;
}
/* .cwU_13 {
  min-width: 110px;
  width: auto;
} */

tr:hover td > input,
tr:hover td > select,
tr:hover td {
  background-color: #fafafa;
}

tr:hover {
  background-color: #dddddd;
  /* border-left: inherit; */
  /* -webkit-box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
    0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  box-shadow: inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0,
    0 1px 2px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  z-index: 1; */
}

.selectedRow {
  -webkit-box-shadow: inset 0 0 0px 1px #886ab5 !important;
  box-shadow: inset 0 0 0px 1px #886ab5 !important;
  background: rgba(136, 106, 181, 0.1) !important;
  font-weight: 500;
  color: inherit;
  position: relative;
  border: 1px solid;
  /* border-bottom: none; */
}

.selectedRow td > input,
.selectedRow td > select,
.selectedRow td {
  background: rgba(136, 106, 181, 0.1) !important;
}

td:has(> [disabled]) {
  background: #f6f6f6 !important;
}
.tdDisables,
select:disabled,
input:disabled {
  background: #f6f6f6 !important;
  color: #969696 !important;
}

.isMissMatch {
  border: 1px solid #ff0000;
  background-color: #ffcccc !important;
  color: #ff0000;
}
.isMissMatchIcon {
  position: absolute;
  color: #ff0000;
  padding: 3px;
}

.claimLnk {
  position: absolute;
  top: 3px;
  left: 3px;
  color: #007bff;
}
.claimLnk:hover {
  cursor: pointer;
}

.selectWithClimlink {
  text-align: right;
  margin-left: 20px;
  width: calc(100% - 20px);
}
</style>
